import { Centrale } from '@urbasolar_dev/urbaconnect-types'

import { toastError } from '../../../infrastructure/hooks/useToast'
import { createSlice } from '../zustandHelpers'
import { IPlantSelectState, IPlantSelectActions } from './plantSelect.slice.interface'
import history from '../../../utils/setupHistory'

export const plantSelectSlice = createSlice<IPlantSelectState, IPlantSelectActions>((set: any) => ({
  plants: [],
  selectedPlant: null,
  plantLoading: false,
  plantError: null,

  setAllUserPlants: async (plants: Centrale[]) => {
    set({ plantLoading: true, plantError: null })
    try {
      set({ plants, plantLoading: false })
    } catch (error) {
      set({ plantLoading: false, plantError: 'Error fetching plants' })
      toastError('Error fetching plants')
    }
  },

  setPlantSelected: (plant) => {
    if (history.location.pathname) {
      history.goBack()
    } else {
      history.push('/')
    }
    set({ selectedPlant: plant })
  },

  unsetPlantSelected: () => {
    set({ selectedPlant: null })
  },
}))
